import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_z8zxh7hf3n: FaireBrandEntity = {
  token: "b_z8zxh7hf3n",
  type: "brand",
  name: "Bathology by Yaphiah",
  avatarUrl:
    "https://cdn.faire.com/fastly/9a6d5d94a99d59987852056bf0455d9c7c02b41dc79e906faaac9962215ee06b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7453678a1c6454c768d198951c116c39208f4b5ff24eac2273ca3e2f5cb666dc.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9a6d5d94a99d59987852056bf0455d9c7c02b41dc79e906faaac9962215ee06b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7453678a1c6454c768d198951c116c39208f4b5ff24eac2273ca3e2f5cb666dc.jpeg",
  location: "Fairburn , GA, USA",
  minimumOrderDollars: 50,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Our products are handcrafted with all-natural ingredients to create a worry free bath oasis. These natural and safe elements of the earth are combined to form mineral rich and aromatic products that not only leave your skin feeling silky, but also aid in the healing of the body through science.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:52:08.328Z",
    importedBy: "entity-db-cli",
  },
};
